import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import images from '../../components/images/noimage.jpeg';
import './MovieDetails.css';
import { jwtDecode as jwt_decode } from 'jwt-decode';
import { APIURLContext } from '../../contexts/APIURLContext';

function MovieDetails() {
    const { id } = useParams();
    const [movie, setMovie] = useState(null);
    const [loading, setLoading] = useState(true);
    const [modalMessage, setModalMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [isInWatchlist, setIsInWatchlist] = useState(false); // New state to track if the movie is in the watchlist
    const apiURL = useContext(APIURLContext); 


    useEffect(() => {
        const fetchMovie = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${apiURL}/movies/${id}`);
                setMovie(response.data);

                // Check if the movie is in the user's watchlist
                const accessToken = localStorage.getItem('accessToken');

                if (accessToken) {
                    const decodedToken = jwt_decode(accessToken);
                    const userId = decodedToken._id;
                    const watchlistResponse = await axios.get(`${apiURL}/watchlist/${userId}`);
                    const watchlistMovieIds = watchlistResponse.data.movies;
                   setIsInWatchlist(watchlistMovieIds.includes(id)); // Check if the movie ID is in the watchlist
                }

         
            } catch (error) {
                console.error('Error fetching movie:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchMovie();
    }, [id, apiURL]);

    const handleAddToWatchlist = async () => {
        try {
            // Retrieve the access token from local storage
            const accessToken = localStorage.getItem('accessToken');

            // Decode the access token to extract user ID
            const decodedToken = jwt_decode(accessToken);

            // Extract the user ID
            const userId = decodedToken._id;
            const username = decodedToken.username

            // Make a request to add movie to watchlist using the extracted user ID
            await axios.post(`${apiURL}/watchlist/${userId}/add`, {
                movieId: id,
                username: username
            });
            
            setIsInWatchlist(true);
            setModalMessage('Movie successfully added to your watchlist.'); 
            setShowModal(true);
        } catch (error) {
            console.error('Error adding movie to watchlist:', error);
            setModalMessage('You must be logged in to perform this action.'); 
            setShowModal(true);
        }
    };

    const handleRemoveFromWatchlist = async () => {
        try {
            // Retrieve the access token from local storage
            const accessToken = localStorage.getItem('accessToken');
    
            // Decode the access token to extract user ID
            const decodedToken = jwt_decode(accessToken);
            const userId = decodedToken._id;
    
            // Make a request to remove movie from watchlist
            await axios.delete(`${apiURL}/watchlist/${userId}/remove/${id}`);
    
            // Update state to reflect that the movie is not in the watchlist anymore
            setIsInWatchlist(false);
            setModalMessage('Movie successfully removed from your watchlist.'); 
            setShowModal(true);
        } catch (error) {
            console.error('Error removing movie from watchlist:', error);
        }
    };
    

    return (
        <div className="container">
            {loading ? (
                <p>Loading...</p>
            ) : (
                <div className="movie-container">
                    <div className="movie-thumbnail-container">
                        <img src={movie.thumbnail || images} alt={movie.title} className="movie-thumbnail" />
                    </div>
                    <div className="movie-details">
                        <h1>{movie.title}</h1>
                        <p><strong>Year Released:</strong> {movie.year}</p>
                        <p><strong>Genres:</strong> {movie.genres.join(', ')}</p>
                        <p><strong>Cast:</strong> {movie.cast.join(', ')}</p>
                        <p>{movie.extract}</p>
                        <div className="button-container">
                            {isInWatchlist ? ( // Display "Remove from Watchlist" button if movie is in the watchlist
                                <Button variant="btn btn-danger" onClick={handleRemoveFromWatchlist}>Remove from Watchlist</Button>
                            ) : (
                                <Button variant="btn btn-danger" onClick={handleAddToWatchlist}>Add to Watchlist</Button>
                            )}
                        </div>
                        <br></br>
                    </div>
                </div>
            )}

                <Modal show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>MoviePro</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{modalMessage}</Modal.Body>
                </Modal>

        </div>
    );
}

export default MovieDetails;
